// docs: https://github.com/altostra/type-validations#readme
import { objectOf, anyOf, arrayOf } from "@altostra/type-validations";
import { boolean, number, string, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

import type { BrandGuidelineDocumentMetadata } from "./types";

export const isBrandGuidelineDocumentMetadata = objectOf<BrandGuidelineDocumentMetadata>({
  id: string,
  name: string,
  content_type: string,
  file_size: anyOf(number, nullOrUndefined),
  updated_at: anyOf(number, nullOrUndefined),
});

export const isGenerativeAiBrandGuidelineResult = objectOf({
  id: string,
  name: string,
  app_group_id: string,
  guideline_purpose: anyOf(string, nullOrUndefined),
  description: anyOf(string, nullOrUndefined),
  // Nullable under brand_guidelines_studio (a guideline can be created before synthesis fills it in).
  brand_personality: anyOf(string, nullOrUndefined),
  exclusions: anyOf(string, nullOrUndefined),
  tone_type: anyOf(string, nullOrUndefined),
  is_default: anyOf(boolean, nullOrUndefined),
  updated_at: anyOf(string, nullOrUndefined),
  status: anyOf(string, nullOrUndefined),
  type: anyOf(string, nullOrUndefined),
  last_edited_by_id: anyOf(string, nullOrUndefined),
  documents: anyOf(arrayOf(isBrandGuidelineDocumentMetadata), nullOrUndefined),
  source_urls: anyOf(arrayOf(string), nullOrUndefined),
});
